export default __webpack_public_path__ + "static/media/GSP10.d6a183d5.png";